import { useState } from 'react';
import { ChangeLanguage, getCurrentLanguage, type LanguageConfig, languages } from '../locale/localization';
import { Button } from '@/components/home/buttons';

export function LanguageDropdown() {
    const [showDropdown, setShowDropdown] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());

    function onBtnClicked() {
        setShowDropdown(!showDropdown);
    }

    function onLanguageClicked(language: LanguageConfig) {
        ChangeLanguage(language);
        setCurrentLanguage(language);
        setShowDropdown(false);
    }

    return (
        <div className="h-stretch relative">
            <button onClick={onBtnClicked} className="h-full rounded outline outline-secondary text-lg px-2 hover:bg-primary" type="button">
                {currentLanguage?.icon}
            </button>
            <div className={`absolute h-[80vh] outline outline-muted pb overflow-y-scroll rounded right-0 z-50 ${showDropdown ? 'scale-y-100' : 'scale-y-0'} transition-transform origin-top`}>
                <ul className="text-md font-normal bg-background/75 outline outline-muted rounded-b-sm divide-y divide-muted overflow-hidden">
                    {languages.map((lang) => (
                        <li key={lang.code}>
                            <button onClick={() => onLanguageClicked(lang)} className="w-full flex justify-between items-center px-3 py-1 gap-2 hover:bg-muted whitespace-nowrap">
                                {lang.display}
                                <span className="text-lg">{lang.icon}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}


export function LanguageSelect() {
    const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());

    function onLanguageChanged(e: React.ChangeEvent<HTMLSelectElement>) {
        const language = languages.find((lang) => lang.code === e.target.value) || languages[0]!;
        ChangeLanguage(language);
        setCurrentLanguage(language);
    }

    return (
        <select onChange={onLanguageChanged} value={currentLanguage?.code} className="px-2 md:px-3 bg-slate-500/50 outline-white/35 appearance-none rounded-full">
            {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>{lang.icon} {lang.display}</option>
            ))}
        </select>
    );
}
